import React from 'react';

const Footer = () => {
  const footerLinks = [
    { label: "About Tutofy", href: "about.html" },
    { label: "Privacy Policy", href: "privacy.html" },
    { label: "Terms of Service", href: "terms.html" },
    { label: "Contact Us", href: "contact.html" },
    { label: "Feedback", href: "feedback.html" },
    { label: "Careers", href: "careers.html" },
    { label: "Partners", href: "partners.html" }
  ];

  const socialLinks = [
    { icon: "fab fa-facebook-f", href: "#" },
    { icon: "fab fa-twitter", href: "#" },
    { icon: "fab fa-instagram", href: "#" }
  ];

  return (
    <footer>
      <div className="footer-nav">
        {footerLinks.map((link, index) => (
          <a key={index} href={link.href}>{link.label}</a>
        ))}
      </div>
      <div className="social-icons">
        {socialLinks.map((social, index) => (
          <a key={index} href={social.href} className="social-btn">
            <i className={social.icon}></i>
          </a>
        ))}
      </div>
      <div className="copyright">
        &copy; 2026 Tutofy - All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;